import { CubePresenter, FlipIntent, Logger, Presenter } from 'wdc-cube'

import { WaitingScope } from 'src/components/waiting/waiting.scopes'
import { MainPresenter } from 'src/main/Main.presenter'
import { IntegracaoMonitoramentoFormKeys } from './form/integracao-monitoramento_form.keys'
import IntegracaoMonitoramentoKeys from './integracao-monitoramento.keys'
import IntegracaoMonitoramentoScope, { HeaderScope } from './integracao-monitoramento.scopes'
import integracaoMonitoramentoService from './integracao-monitoramento.service'
import { ResultadoAnaliseVisaoCedenteKeys } from './resultado/resultado_analise_visao_cedente.keys'

const LOG = Logger.get('IntegracaoMonitoramentoPresenter')

export class IntegracaoMonitoramentoPresenter extends CubePresenter<MainPresenter, IntegracaoMonitoramentoScope> {
    // :: Fields

    private readonly __headerBar: Presenter<HeaderScope, IntegracaoMonitoramentoPresenter>

    // :: Constructor

    public constructor(app: MainPresenter) {
        super(app, new IntegracaoMonitoramentoScope())
        this.__headerBar = new Presenter(this, this.scope.header)
    }

    // :: Methods

    public override release() {
        this.app.releaseToolbar(this.__headerBar)
        super.release()
        LOG.debug('Finalized')
    }

    public override async applyParameters(intent: FlipIntent, initialization: boolean): Promise<boolean> {
        const keys = new IntegracaoMonitoramentoKeys(this.app, intent)

        this.app.scope.toolbar = this.__headerBar.scope

        keys.parentSlot(this.scope)

        if (initialization) {
            await this.#initialize()
        }
        if (!this.scope.monitorados || this.scope.monitorados.length === 0) {
            await this.handleFind()
        }
        return keys.allow
    }

    async #initialize() {
        LOG.debug('initialize')
        this.scope.onFind = this.action(this.handleFind)
        this.scope.onNew = this.action(this.handleNew)
        this.scope.onEdit = this.action(this.handleEdit)
        this.scope.onDelete = this.action(this.handleDelete)
        this.scope.onReprocess = this.action(this.handleReprocess)
        this.scope.onShowResults = this.action(this.handleShowResults)
    }

    private async handleFind() {
        try {
            this.scope.waiting = new WaitingScope()
            const monitorados = await integracaoMonitoramentoService.fetchMonitoramentos()
            this.scope.monitorados = monitorados
        } catch (caught) {
            LOG.error('handleFind', caught)
            throw caught
        } finally {
            this.scope.waiting = undefined
        }
    }

    private async handleNew() {
        const target = new IntegracaoMonitoramentoFormKeys(this.app)
        await target.flip()
    }

    private async handleEdit(id: number) {
        const target = new IntegracaoMonitoramentoFormKeys(this.app)
        target.monitoramentoId = id
        await target.flip()
    }

    private async handleDelete(id: number) {
        try {
            if (!id) {
                throw new Error('Monitoramento deve ser selecionado')
            }
            if (!confirm('Confirma a exclusão do monitoramento?')) {
                return
            }
            this.scope.waiting = new WaitingScope()

            await integracaoMonitoramentoService.deleteMonitoramento(id)
            await this.handleFind()
        } catch (caught) {
            LOG.error('handleDelete', caught)
            throw caught
        } finally {
            this.scope.waiting = undefined
        }
    }

    private async handleReprocess(id: number) {
        if (!id) {
            throw new Error('Documento com visão cedente deve ser selecionado')
        }

        try {
            await integracaoMonitoramentoService.reprocessVisaoCedente(id)

            await this.handleFind()
        } catch (caught) {
            LOG.error('handleFind', caught)
            throw caught
        }
    }

    private async handleShowResults(id: number) {
        try {
            if (!id) {
                throw new Error('Bordero deve ser selecionado')
            }
            const keys = new ResultadoAnaliseVisaoCedenteKeys(this.app)
            keys.visaoCedenteId = id
            await keys.flip()
        } catch (caught) {
            LOG.error('handleDelete', caught)
            throw caught
        }
    }
}

export default IntegracaoMonitoramentoPresenter
